import currency from "currency.js";
import { defaults } from "lodash";

export function formatCurrency(value, params) {
  const { formatWithSymbol, precision } = defaults(params, {
    formatWithSymbol: true,
    precision: 2
  });

  return currency(value, {
    symbol: formatWithSymbol ? "DA" : " ",
    pattern: "# !",
    negativePattern: "-# !",
    formatWithSymbol,
    separator: " ",
    decimal: ",",
    precision
  }).format();
}
